import { Component, EventEmitter, Input, Output } from '@angular/core';

import { FeeCode } from 'src/app/enums/fee.code';
import { Fees } from 'src/app/model/fees';
import { CommonUtil } from 'src/app/services/common.util';

@Component({
    selector: 'app-enterprise-fees',
    templateUrl: './enterprise-fees.component.html',
    styleUrls: ['./enterprise-fees.component.css'],
})
export class EnterpriseFeesComponent {
    @Input() enterpriseFeeList: Array<Fees>;
    @Input() editEnterprise = false;
    @Input() showEditPencil = true;
    @Input() parentToUpdate = false;
    @Input() title = 'Enterprise User';
    @Output() updateFee = new EventEmitter();

    feeCode = FeeCode;
    feeLabel = this.commonUtil.getFeeLabels();

    constructor(public commonUtil: CommonUtil) { }

    changeView() {
        this.editEnterprise = !this.editEnterprise;
    }

    submit() {
        this.updateFee.emit('enterprise');
        this.changeView();
    }

}
